enum EApiRoleGroup {
  accessList = '/accesses',
  roleGroup = '/roles',
  roleGroupDetail = '/roles/:id',
  roleGroupNameExist = '/roles/is-exists',
  roleGroupUpdateLog = '/roles/:id/update-logs',
}

export default EApiRoleGroup;
